var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.83194 0V8H8.83194V0H0.83194ZM0.83194 10V18H8.83194V10H0.83194ZM6.83194 16H2.83194V12H6.83194V16ZM10.8319 0V8H18.8319V0H10.8319ZM16.8319 6H12.8319V2H16.8319V6ZM10.8319 10V18H18.8319V10H10.8319ZM16.8319 16H12.8319V12H16.8319V16Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.83194 0V8H8.83194V0H0.83194ZM0.83194 10V18H8.83194V10H0.83194ZM6.83194 16H2.83194V12H6.83194V16ZM10.8319 0V8H18.8319V0H10.8319ZM16.8319 6H12.8319V2H16.8319V6ZM10.8319 10V18H18.8319V10H10.8319ZM16.8319 16H12.8319V12H16.8319V16Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCard);
export default __webpack_public_path__ + "static/media/viewCard.69de0bc73f81d9b704fc34ff777b09a1.svg";
export { ForwardRef as ReactComponent };